// =============================================================================
// accesVues.js : qui peut ouvrir quelle vue (périmètre cible), source UNIQUE.
// -----------------------------------------------------------------------------
// Sortie d'App.jsx le 14/10/2026, à l'identique : App.jsx en tire la page
// « navrés » (evaluateViewAccess) ; buildNavModules (navConstants.js) en tire le
// cadenas ouvert des pages réservées aux administrateurs (« admin »). Pur :
// aucune importation.
// =============================================================================

// Table view → périmètre cible. Absent = "transverse" (tout membre connecté).
//   "transverse" | "admin" | "hab:RH" | "hab:DPO" | "dom:<id>"
export const VIEW_ACCESS = {
  // Consultation ouverte à tous (valorisation de la richesse Aramis) :
  //   dataviz, veille AO, veille-juridique, referentiel-organismes,
  //   nouvelles-mutuelles, annuaire, panorama territorial… = transverse.
  // Seules les ressources sensibles ci-dessous déclenchent la page navrés.
  "gel-avoirs-ppe":"dom:pil",   // LCB-FT — pilotage éco. & réglementaire + admin
  "preparer-presentation":"admin",
  "hygie":"hab:DPO",
  // Ancienne veille RGPD de Calypso (retirée le 21/10/2026) : elle redirige
  // vers la veille juridique, ouverte à tout membre ; la garde des pages de
  // Calypso (« hygie- ») ne s'y applique pas.
  "hygie-veille":"transverse",
  // Accueil RH + sa vitrine (non couverts par le préfixe « rh- ») = habilitation
  // RH : le blocage (page navrés) se fait dès le Header, pas seulement sur les
  // entrées détaillées.
  "rh":"hab:RH",
  "accueil-rh":"hab:RH",
  // Outils d'administration désormais visibles dans le menu (modèle « tout
  // visible + page navrés ») mais réservés aux admins Enio.
  "screen":"admin", "historiques":"admin",
  "admin-budget":"admin", "admin-budget-outils":"admin", "admin-depenses":"admin", "admin-ndf":"admin", "emailing":"admin",
  "budget-accueil":"admin", "budget-simulation":"admin", "budget-exercice":"admin", "budget-situation":"admin", "budget-depenses":"admin", "budget-compte":"admin", "budget-paie":"admin",
  // Portail expert-comptable : accessible aux admins + aux détenteurs du rôle EC.
  "compta-ec":"hab:EC",
  // Documents préparatoires d'une séance : EXCEPTION au préfixe « themis- »
  // (admin only). C'est la cible du lien porté par les convocations — donc
  // ouverte à tout délégué connecté. Le vrai verrou n'est pas ici : la Cloud
  // Function refuse quiconque ne figure pas parmi les participants de la
  // séance demandée (listSessionDocs / getSessionDocUrl).
  "themis-documents-seance":"transverse",
  // Confirmation de présence par lien tokenisé (mail de convocation) : page
  // publique, le verrou est le token côté CF.
  "themis-presence":"transverse",
  "themis-pouvoir":"transverse",
  "themis-pouvoir-confirmation":"transverse",
  // Signature de l'émargement (23/09/2026) : lien à jeton dédié, sans compte.
  "themis-emargement":"transverse",
  "themis-repas":"transverse",
  // Préparation des séances (Pilotage, 04/09/2026) : « transverse » ici parce
  // que le verrou est le ternaire de la vue — admin → hub Thémis, membre →
  // carte d'orientation vers les documents de SON instance. Sans cette
  // exception, le préfixe « themis- » (admin) envoyait un membre qui suivait
  // le lien e-mail du Président sur la page navrés AVANT la redirection.
  "pilotage-seances":"transverse",
  "themis-instances":"transverse", "themis":"transverse", "themis-preparer":"transverse",
  "accueil-pilotage":"admin",
  // Vue historique de la console (audit du 28/09/2026) : le préfixe « admin »
  // ne la couvre pas, elle restait donc « transverse ».
  "agora-admin":"admin",
  // Console de la séance en direct par ses deux entrées de Pilotage (18/10/2026).
  "seance-emargement":"admin", "seance-scrutins":"admin",
  // Pilotage d'Hestia (lot H0) : écran d'administrateur ; la couche d'accès
  // le refuse aussi côté serveur.
  "pilotage-hestia":"admin",
  // Notes institutionnelles (B6) : administrateurs d'Enio seuls ; la fonction
  // notesInstitutionnelles le refuse aussi côté serveur (jeton vérifié).
  "notes-institutionnelles":"admin", "note-institutionnelle":"admin", "notes-institutionnelles-modeles":"admin",
  // Doctrine d'Enio (socle) : équipe d'Enio (administrateurs) seule ; la
  // fonction doctrine le refuse aussi côté serveur (jeton vérifié).
  "doctrine":"admin", "doctrine-theme":"admin", "doctrine-import":"admin", "doctrine-propositions":"admin",
  // Les débats (doctrine ouverte, lot L4) : la liste et la fiche d'un débat.
  "doctrine-debats":"admin", "doctrine-debat":"admin",
  // Administration › Synchronisation (13/10/2026, ouverte aux administrateurs
  // le 19/10/2026) : hors du préfixe « admin- » ; chaque échange garde sa
  // garde au serveur.
  "super-synchronisation":"admin",
};
// Préfixes (évalués si la clé exacte est absente de VIEW_ACCESS).
// Thémis (instances + événements + contacts) et sous-pages event-* = admin Enio.
export const VIEW_ACCESS_PREFIX = [
  ["themis-","admin"],
  ["event-","admin"],
  ["hygie-","hab:DPO"],
  ["rh-","hab:RH"],
  ["admin-super-","admin"],
  ["admin","admin"],
];
export const accessScopeForView = (view) => {
  if (VIEW_ACCESS[view]) return VIEW_ACCESS[view];
  for (const [pfx, scope] of VIEW_ACCESS_PREFIX) if (String(view||"").startsWith(pfx)) return scope;
  return "transverse";
};
